<div class="vtmn-flex vtmn-ml-0 vtmn-mr-auto">
  <img class="vtmn-m-auto digitalPeople" src="/img/digitalforpeople.png" />
</div>
